import React from 'react';

import { Box, Skeleton } from '@mui/material';

import Container from '@components/store/container';

const ProductCriteriaCertificateSkeleton = () => {
  return (
    <Box minHeight={{ xs: '570px', md: '364px', lg: '400px' }} py={10}>
      <Container
        containerSx={{
          px: { xs: 3, lg: 0 },
          display: 'grid',
          gridTemplateColumns: { md: '1fr 1fr', lg: '1fr 30%' },
          gap: { xs: 5, lg: 8 },
        }}
      >
        <Box sx={{ display: 'grid', gap: 2 }}>
          <Skeleton animation="wave" variant="rectangular" height={32} sx={{ borderRadius: 2 }} />
          <Skeleton animation="wave" variant="rectangular" height={192} sx={{ borderRadius: 2 }} />
        </Box>
        <Skeleton animation="wave" variant="rectangular" width="100%" height={240} sx={{ borderRadius: 2 }} />
      </Container>
    </Box>
  );
};

export default ProductCriteriaCertificateSkeleton;
